<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-info">
          <div class="info-item">
            <div class="info-icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Website:</span>
              <a href="https://www.acimaging.org" target="_blank" rel="noopener noreferrer" class="info-value">
                www.acimaging.org
              </a>
            </div>
          </div>
          <div class="info-item">
            <div class="info-icon">
              <i class="fas fa-envelope"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Email:</span>
              <a href="mailto:isaci.contact@gmail.com" class="info-value">
                isaci.contact@gmail.com
              </a>
            </div>
          </div>
          <div class="info-item">
            <div class="info-icon">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="info-content">
              <span class="info-label">Address:</span>
              <span class="info-value">33A Pagoda Street, Singapore 059192</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>Copyright &copy;{{ currentYear }} ISACI. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(90deg, rgba(29, 151, 208, 1) 30%, rgba(0, 14, 112, 1) 100%);
  padding: 3rem 0 1.5rem;
  margin-top: 1rem;
  border-top: 3px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  position: relative;
}

.footer-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
  max-width: 1200px;
  width: 100%;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex: 1;
  min-width: 280px;
  max-width: 350px;
}

.info-icon {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.info-icon:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.info-icon i {
  color: rgba(29, 151, 208, 1);
  font-size: 1.2rem;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1;
}

.info-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.info-value {
  color: #ffffff;
  font-size: 1.05rem;
  font-weight: 500;
  line-height: 1.6;
  transition: color 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.info-value a {
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.info-value a:hover {
  color: #ffeb3b;
  border-bottom-color: #ffeb3b;
  text-shadow: 0 0 8px rgba(255, 235, 59, 0.5);
}

.footer-bottom {
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.footer-bottom p {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  font-weight: 400;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    padding: 2rem 0 1rem;
  }

  .footer-info {
    flex-direction: column;
    gap: 2rem;
    align-items: center;
  }

  .info-item {
    min-width: 100%;
    max-width: 100%;
    justify-content: center;
  }

  .info-content {
    text-align: center;
  }
}

@media (max-width: 576px) {
  .footer-info {
    gap: 1.5rem;
  }

  .info-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .info-icon {
    margin-bottom: 0.5rem;
    width: 50px;
    height: 50px;
  }

  .info-icon i {
    font-size: 1.3rem;
  }
}
</style> 